import { LogoMark } from "@/components/brand/logo";
import { DotLoader } from "@/components/ui/spinner";

/** Same geometry as the inline boot shell in index.html, so the handoff never shifts. */
export function AppShellSkeleton({ label = "Preparing your workspace" }: { label?: string }) {
	return (
		<div className="bg-dot-grid fixed inset-0 flex">
			<div className="w-(--sidebar-width) shrink-0" />
			<div className="my-2 mr-2 flex flex-1 flex-col items-center justify-center gap-4 rounded-[10px] border bg-card">
				<LogoMark className="size-7 opacity-90" />
				<div className="flex items-center gap-2 text-muted-foreground">
					<DotLoader />
					<span className="mono-label">{label}</span>
				</div>
			</div>
		</div>
	);
}
